import React, { useContext } from 'react';
import { Link } from 'gatsby';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPhoneAlt } from '@fortawesome/free-solid-svg-icons'

import { GlobalContext } from '../../state/GlobalContext';

import Nav from './Nav'
import ViewQuote from "../simple/ViewQuote"
import Wrapper from './Wrapper';

import logo from '../../assets/images/logo.svg';

export default function Header() {

    const { quoteItems } = useContext(GlobalContext);
    const quoteItemsCount = quoteItems.items.length || 0

    return (
        <header className='relative z-20'>
            <div className="header-top bg-primary-green py-2">
                <Wrapper>
                    <div className="flex justify-between md:justify-end items-center">
                        <p className="text-white text-right leading-tight"><a href="tel:+4408081648512" className="hover:underline"><FontAwesomeIcon icon={faPhoneAlt} size="1x" className='mr-3' /> <span className="hidden sm:inline">Call us for a quote</span> 0808 164 8512</a></p>
                        <ViewQuote count={quoteItemsCount} className="ml-4" />
                    </div>
                </Wrapper>
            </div>
            <div className="header-main py-8">
                <Wrapper className="grid grid-cols-2 lg:grid lg:grid-cols-header-nav lg:gap-5">
                    <Link to="/"><img src={logo} alt="The Air Products logo in green" /></Link>
                    <Nav />
                </Wrapper>
            </div>
        </header>
    );
}